module.exports = __webpack_public_path__ + "img/image.72e135c3.svg";